import { render, staticRenderFns } from "./AllAchievementsModal.vue?vue&type=template&id=482c28a8"
import script from "./AllAchievementsModal.vue?vue&type=script&lang=js"
export * from "./AllAchievementsModal.vue?vue&type=script&lang=js"
import style0 from "./AllAchievementsModal.vue?vue&type=style&index=0&id=482c28a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports